import React from "react";
import { interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { COLORS, SPRING } from "../constants";

export const FlowArrow: React.FC<{
  fromX: number;
  fromY: number;
  toX: number;
  toY: number;
  delay?: number;
  color?: string;
  strokeWidth?: number;
  dashed?: boolean;
  animated?: boolean;
}> = ({
  fromX,
  fromY,
  toX,
  toY,
  delay = 0,
  color = COLORS.accentBlue,
  strokeWidth = 2,
  dashed = false,
  animated = true,
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const appear = spring({
    frame: frame - delay,
    fps,
    config: SPRING.gentle,
  });

  const dx = toX - fromX;
  const dy = toY - fromY;
  const angle = Math.atan2(dy, dx);

  // Arrow head size
  const headLen = 10;

  // Draw progress
  const progress = interpolate(appear, [0, 1], [0, 1]);
  const currentEndX = fromX + dx * progress;
  const currentEndY = fromY + dy * progress;

  // Animated dash offset for flowing effect
  const dashOffset = animated ? frame * 2 : 0;

  return (
    <svg
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        overflow: "visible",
      }}
    >
      <defs>
        <linearGradient
          id={`arrow-grad-${fromX}-${fromY}-${toX}-${toY}`}
          x1={fromX}
          y1={fromY}
          x2={toX}
          y2={toY}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor={color} stopOpacity={0.3} />
          <stop offset="100%" stopColor={color} stopOpacity={0.9} />
        </linearGradient>
      </defs>

      {/* Main line */}
      <line
        x1={fromX}
        y1={fromY}
        x2={currentEndX}
        y2={currentEndY}
        stroke={`url(#arrow-grad-${fromX}-${fromY}-${toX}-${toY})`}
        strokeWidth={strokeWidth}
        strokeDasharray={dashed ? "8 4" : "none"}
        strokeDashoffset={dashed ? -dashOffset : 0}
        opacity={interpolate(appear, [0, 0.1], [0, 1])}
      />

      {/* Arrow head */}
      {progress > 0.8 && (
        <polygon
          points={`
            ${currentEndX},${currentEndY}
            ${currentEndX - headLen * Math.cos(angle - 0.4)},${currentEndY - headLen * Math.sin(angle - 0.4)}
            ${currentEndX - headLen * Math.cos(angle + 0.4)},${currentEndY - headLen * Math.sin(angle + 0.4)}
          `}
          fill={color}
          opacity={interpolate(progress, [0.8, 1], [0, 1])}
        />
      )}
    </svg>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
